module.exports = __webpack_public_path__ + "static/media/raiff-screen05.7306bdec.jpg";